import type { IInfrastructure } from 'shared/repositories/commercial-buildings/entities/infrastructure/Infrastructure';

/**
 * Элементы инфраструктуры в порядке и с подписями `Infrastructure` монолита
 * (`cian/business_shopping_centers/domain/entities/business_shopping_center.py`, `flat_list`).
 * Остальные поля контракта монолит не показывает
 */
export const INFRASTRUCTURE_LABELS: Array<[keyof IInfrastructure, string]> = [
  ['hasAtm', 'банкомат'],
  ['hasFoodCourt', 'фуд-корт'],
  ['hasCafe', 'кафе'],
  ['hasBeautyShop', 'салон красоты'],
  ['hasSupermarket', 'супермаркет'],
  ['hasGameRoom', 'игровая комната'],
  ['hasBankDepartment', 'отделение банка'],
  ['hasBuffet', 'буфет'],
  ['hasCanteen', 'столовая'],
  ['hasCarService', 'автосервис'],
  ['hasCarWash', 'автомойка'],
  ['hasCentralReception', 'центральная рецепция'],
  ['hasOfficeSpace', 'Офисные помещения'],
  ['hasCinema', 'кинотеатр'],
  ['hasClothesStudio', 'ателье одежды'],
  ['hasConferenceRoom', 'конференц-зал'],
  ['hasExhibitionAndWarehouseComplex', 'выставочно-складской комплекс'],
  ['hasFitnessCentre', 'фитнес-центр'],
  ['hasHotel', 'гостиница'],
  ['hasMedicalCenter', 'медицинский центр'],
  ['hasMinimarket', 'минимаркет'],
  ['hasNotaryOffice', 'нотариальная контора'],
  ['hasPark', 'парк'],
  ['hasPharmacy', 'аптека'],
  ['hasPool', 'бассейн'],
  ['hasRestaurant', 'ресторан'],
  ['hasShoppingArea', 'торговая зона'],
  ['hasStudio', 'фотосалон'],
  ['hasWarehouse', 'складские помещения'],
];

/**
 * Элементы инфраструктуры, которых нет у монолита (решение пользователя: показываем после `INFRASTRUCTURE_LABELS`).
 * Подписи — из описаний контракта, порядок — по алфавиту поля. В генерации описания не участвуют
 */
export const EXTRA_INFRASTRUCTURE_LABELS: Array<[keyof IInfrastructure, string]> = [
  ['hasAquapark', 'аквапарк'],
  ['hasAutomaticGates', 'автоматические ворота'],
  ['hasBabySitting', 'беби-ситинг'],
  ['hasBasement', 'подвал/погреб'],
  ['hasBowling', 'боулинг'],
  ['hasEntryByPass', 'въезд по пропускам'],
  ['hasHourSecurity', 'круглосуточная охрана'],
  ['hasInspectionPit', 'смотровая яма'],
  ['hasRink', 'каток'],
  ['hasSlotMachines', 'игровые автоматы'],
  ['hasTire', 'шиномонтаж'],
  ['hasVideoSurveillance', 'видеонаблюдение'],
];
